import { Grid } from "@material-ui/core";
import React, {  FunctionComponent } from "react";
import { AppLayoutBody } from "./AppLayoutBody";
import { AppLayoutFooter } from "./AppLayoutFooter";
import { AppLayoutHeader } from "./AppLayoutHeader";

type AppLayout = FunctionComponent & {
  Header: FunctionComponent;
  Body: FunctionComponent;
  Footer: FunctionComponent;
};

export const AppLayout: AppLayout = ({ children }) => {
  return (
    <Grid container justify="center">
      {children}
    </Grid>
  );
};

AppLayout.Header = AppLayoutHeader;
AppLayout.Body = AppLayoutBody;
AppLayout.Footer = AppLayoutFooter;
